module.exports = __webpack_public_path__ + "static/media/Alcohol.74f4a6b7.jpg";